var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73545 3.75271L9.00808 6.8354C9.00808 7.37812 9.45144 7.81812 10.0004 7.81812C10.5484 7.81812 10.9927 7.37812 10.9927 6.8354L11.2653 3.75271C11.2653 3.0609 10.6989 2.5 10.0004 2.5C9.30182 2.5 8.73545 3.0609 8.73545 3.75271ZM8.95844 17.0951C9.00532 17.1378 9.04126 17.1705 9.0582 17.1873C9.32623 17.3918 9.65394 17.5 10.0064 17.5C10.3222 17.5 10.638 17.4036 10.8932 17.2109C11.0703 17.0873 11.3549 16.8018 11.3549 16.8018C12.461 15.7909 14.1252 13.2764 14.6604 12.001C14.6714 12.001 14.9881 11.2428 15 10.8819V10.8337C15 10.2801 14.6842 9.76282 14.1739 9.49828C13.9628 9.38897 13.4458 9.28642 13.2006 9.23781C13.1216 9.22214 13.0709 9.21207 13.0677 9.20919C12.3389 9.10101 11.2209 9.02919 9.99449 9.02919C8.70571 9.02919 7.53993 9.10101 6.82302 9.23283C6.81109 9.23283 6.15476 9.36555 5.9363 9.4501C5.62053 9.58282 5.35249 9.82282 5.18267 10.1237C5.0615 10.3646 5 10.6174 5 10.8819C5.01285 11.1592 5.1946 11.6764 5.27997 11.881C5.81513 13.2282 7.5638 15.8037 8.63319 16.79C8.7445 16.9002 8.87064 17.0151 8.95844 17.0951Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.ed86f592e7c326eebdd40754eb6dcaf5.svg";
export { ForwardRef as ReactComponent };